import { motion } from "framer-motion";
import { ShieldCheck, MessagesSquare, Sparkles, HeartHandshake } from "lucide-react";
import { useLang } from "../i18n";

export const PILLARS = {
  ar: {
    eyebrow: "لماذا THEMAYA",
    title_a: "تجربة تشافي",
    title_b: "لا تشبه غيرها",
    items: [
      { icon: ShieldCheck, title: "مساحة آمنة وسرّية", text: "كل ما يُقال هنا يبقى بيننا — بلا أحكام، بلا تقييم، بخصوصية كاملة." },
      { icon: MessagesSquare, title: "منهجية الاستجواب الذاتي", text: "أسئلة مدروسة توصلك لإجاباتك بنفسك، بدل النصائح الجاهزة التي لا تدوم." },
      { icon: Sparkles, title: "نتائج تشعر/تشعرين بها", text: "أدوات عملية تُطبَّق من أول جلسة — لا نظريات، بل تحوّل حقيقي." },
      { icon: HeartHandshake, title: "مرافقة مستمرة", text: "لستَ/لستِ وحدك بعد الجلسة — دعم ومتابعة حقيقية طوال رحلتك." },
    ],
  },
  en: {
    eyebrow: "WHY THEMAYA",
    title_a: "A healing experience",
    title_b: "unlike any other",
    items: [
      { icon: ShieldCheck, title: "A safe, confidential space", text: "Everything you share stays between us — no judgment, complete privacy." },
      { icon: MessagesSquare, title: "Self-inquiry method", text: "Carefully crafted questions that lead you to your own answers, not ready-made advice." },
      { icon: Sparkles, title: "Results you can feel", text: "Practical tools you apply from the very first session — real transformation, not theory." },
      { icon: HeartHandshake, title: "Continuous support", text: "You are not alone after the session — real support and follow-up throughout your journey." },
    ],
  },
};

export const Pillars = () => {
  const { lang } = useLang();
  const s = PILLARS[lang];
  return (
    <section data-testid="pillars-section" className="relative py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <p className="text-luxury-gold text-sm tracking-[0.35em] mb-6">{s.eyebrow}</p>
          <h2 data-testid="pillars-title" className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl text-luxury-bone leading-[1.25]">
            {s.title_a} <span className="gold-shimmer italic">{s.title_b}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {s.items.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`pillar-card-${i}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-luxury-surface border border-luxury-border rounded-3xl p-8 hover:border-luxury-gold hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(201,164,92,0.12)] transition-all duration-500"
            >
              <div className="w-14 h-14 rounded-2xl border border-luxury-border flex items-center justify-center mb-6 group-hover:border-luxury-gold group-hover:bg-luxury-gold/10 transition-all duration-500">
                <p.icon className="w-7 h-7 text-luxury-gold" strokeWidth={1.25} />
              </div>
              <h3 className="font-serif text-2xl text-luxury-bone mb-3">{p.title}</h3>
              <p className="text-luxury-gray text-sm leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
